import Path from 'path';
import fs from 'fs';
function findNuxtConfig(startPath) {
    let currentDir = startPath;
    while (currentDir !== Path.parse(currentDir).root) {
        // js & ts for 
        const configTs = Path.join(currentDir, 'nuxt.config.ts');
        const configJs = Path.join(currentDir, 'nuxt.config.js');
        if (fs.existsSync(configTs)) return configTs;
        if (fs.existsSync(configJs)) return configJs;
        // Move up one level
        currentDir = Path.dirname(currentDir);
    }

    return null; // nuxt.config not found
}

export function configIntegration(targetPath, moduleName) {
    const modulePath = `~/${Path.join(targetPath, moduleName)}`; // Relative path format
    // start searching from the current working directory
    const nuxtConfigFile = findNuxtConfig(Path.join(process.cwd(), targetPath));
    if (!nuxtConfigFile) {
        console.error('nuxt.config.ts or nuxt.config.js not found in any parent directory.');
        process.exit(1);
    }
    // read the Nuxt config file
    let configContent = fs.readFileSync(nuxtConfigFile, 'utf8');
    // regEx to find `extend: []` inside the config
    // const parentExtendRegex = /extend:\s*\[(.*?)\]/s;

    const parentExtendRegex = /extends:\s*\[(.*?)\]/s;;
    const match = configContent.match(parentExtendRegex);
    // console.log(match);
    if (match) {
        let extendArrayContent = match[1].trim();
        // console.log("extendArrayContent");
        // console.log(extendArrayContent);

        // Convert to a proper array format
        let extendArray = extendArrayContent
            ? extendArrayContent.split(',').map(item => item.trim().replace(/['"]/g, ''))
            : [];

        // Check if the module path is already inside parent.extend array
        if (!extendArray.includes(modulePath)) {
            extendArray.push(modulePath); // Push new module path
            const updatedExtendArray = `extends: [\n${extendArray.map(item => `'${item}'`).join(',\n      ')}\n    ]\n `;

            // Replace only the parent.extend array inside the file
            configContent = configContent.replace(parentExtendRegex, updatedExtendArray);
            fs.writeFileSync(nuxtConfigFile, configContent, 'utf8');
            console.log(`Added "${modulePath}" to extend[] in ${nuxtConfigFile}`);
        } else {
            console.log(`Module "${modulePath}" is already in parent.extend[]`);
        }
    } else {
        // if extend does not exist create it
        configContent = configContent.replace(
            /(export default defineNuxtConfig\s*\(\s*{)/,
            `$1\n  extends: [\n    '${modulePath}'\n  ],`
        );
        fs.writeFileSync(nuxtConfigFile, configContent, 'utf8');
        console.log(`Created extend[] and added "${modulePath}" in ${nuxtConfigFile}`);
    }

}